<template>
  <v-app>
    <Topbar v-if="userLogged"
            v-bind:userName="userName"
            v-bind:companyName="companyName"/>

    <v-content fluid style="background-color:rgb(244,244,244);height:100vh;">
      <Titlebar v-if="userLogged"/>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Topbar from './controls/Topbar'
import Titlebar from './controls/Titlebar'

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';

import {globalStore, vessels} from "./main.js"

export default {
  name: 'App',
  components: {
    Topbar,
    Titlebar
  },
  data() {
    return {
      //
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeUnload);

    if (window.$cookies.isKey('user')) {
      globalStore.userProfile = window.$cookies.get('user');
      globalStore.alertFilters = JSON.parse(localStorage.getItem('alertFilters'));
      globalStore.alerts = JSON.parse(localStorage.getItem('alerts'));
      globalStore.userLogged = true;
      globalStore.auth_token = globalStore.userProfile.jwt;

      vessels.vessels = JSON.parse(localStorage.getItem('vessels'));
      globalStore.config = JSON.parse(localStorage.getItem('config'));
    }
  },
  mounted() {
    window.$cookies.remove('vessel');
  },
  methods: {
    beforeUnload: function () {
      window.$cookies.remove('vessel');
    },
    setParams: function () {
      if (
          window.location.pathname.toLowerCase().indexOf('dashboard') < 0
          && Object.keys(this.$route.params).indexOf('vessel') > -1
      ) {
        if (Object.values(vessels.vessels).length) {
          let vessel = vessels.vessels.filter((vessel) => {
            return vessel.name == this.$route.params['vessel']
          });

          if (!vessel.length) {
            this.$router.push({path: '/dashboard'})
          }

          vessel = vessel[0]
          globalStore.selectedVessel = this.$route.params['vessel'];
          globalStore.selectedIMO = vessel['imo'];
          globalStore.selectedEngine='';

          if (
              Object.keys(this.$route.params).indexOf('eng')
              && !!this.$route.params.eng
              && ['port', 'stbd'].indexOf(this.$route.params.eng.toLowerCase()) > -1
          ) {
            globalStore.selectedEngine = this.$route.params.eng;
          } else {
            globalStore.selectedEngine = 'Port';
          }

          globalStore.twinEngine = vessel['has_twin'];
          globalStore.gasEngine = vessel['is_gas'];
        }
      } else if (
          window.location.pathname.toLowerCase().indexOf('user-settings') < 0
          && window.location.pathname.toLowerCase().indexOf('alerts') < 0
      ) {
        this.$router.push({path: '/dashboard'})
      }
    }
  },
  computed: {
    userName: function () {
      return globalStore.userProfile.displayName;
    },
    companyName: function () {
      return globalStore.userProfile.company;
    },
    userLogged: function () {
      return globalStore.userLogged;
    },
    vessels: function () {
      return vessels.vessels
    }
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.setParams()
      },
      deep: true,
      immediate: true
    },
    vessels: {
      handler: function () {
        this.setParams()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>

